export default __webpack_public_path__ + "static/media/photo 21.5ab4801e.jpg";